module.exports = __webpack_public_path__ + "static/media/inactiveLike@3x.ba5b1cd9.png";